@if (representative.value.company_updated_at) {
  <span class="company-updated-at">
    <span>Utolsó frissítés:</span>
    <span>
      {{ representative.value.company_updated_at | date: "yyyy.MM.dd. HH:mm" }}
    </span>
  </span>
}
<h2>{{ index }} - {{ is_standalone ? "Önálló" : "Együttes" }}</h2>
<div class="flex vcenter rep-box">
  <form [formGroup]="representative">
    <payee-form-field [aiFilled]="isAiFilled(representative.controls.name)">
      <span payee-label>Név</span>
      <input
        payee-input
        formControlName="name"
        [matAutocomplete]="auto"
        (input)="onCompanySearchInput($event)"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [requireSelection]="false"
        (optionSelected)="companySelected($event)"
      >
        @for (option of autocompleteOptions; track option.tax_number || option.name) {
          <mat-option [value]="option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </payee-form-field>
    <payee-form-field>
      <span payee-label>Adószám</span>
      <input
        payee-input
        formControlName="tax_number"
      />
    </payee-form-field>
    <payee-form-field>
      <span payee-label>Jogalany típusa</span>
      <payee-autocomplete
        formControlName="party_type_id"
        [options]="partyTypeOptions"
        [displayWith]="partyTypeDisplayWith"
        [clearable]="true"
        [requireSelection]="true"
        [showAllOptionsOnFocus]="true"
      ></payee-autocomplete>
    </payee-form-field>
    @if (!isHouse()) {
      <payee-form-field>
        <span payee-label>Nyilvántartási szám</span>
        <input
          payee-input
          formControlName="registration_number"
        />
      </payee-form-field>
      <payee-form-field>
        <span payee-label>Illetékes hivatal</span>
        <payee-autocomplete
          formControlName="registration_office_id"
          [options]="registrationOfficeOptions"
          [displayWith]="registrationOfficeDisplayWith"
          [clearable]="true"
          [requireSelection]="true"
          [showAllOptionsOnFocus]="true"
        ></payee-autocomplete>
      </payee-form-field>
    }
    <payee-form-field [aiFilled]="isAiFilled(representative.controls.type_id)">
      <span payee-label>Típus</span>
      <payee-autocomplete
        formControlName="type_id"
        [options]="representativeTypeOptions"
        [displayWith]="representativeTypeDisplayWith"
      ></payee-autocomplete>
    </payee-form-field>
    <app-address-form
      [showToggle]="representative.enabled"
      [countries]="countries"
      [form]="$any(representative.get('address'))"
    ></app-address-form>
  </form>
  <button
    payee-button
    class="add-rep"
    [disabled]="representative.disabled"
    (click)="addChildRep()"
  >
    +
  </button>
  <button
    payee-icon-button
    color="white"
    class="remove-rep"
    [disabled]="representative.disabled"
    (click)="removeRep()"
  >
    <payee-icon name="trash-red"></payee-icon>
  </button>
</div>

<app-representatives-form
  [isChild]="true"
  [representativeTypes]="representativeTypes"
  [representatives]="$any(representative.get('representatives'))"
  [countries]="countries"
  [index]="index"
></app-representatives-form>
